(function () {

  'use strict';

  function pxTreeItems() {
    return {
      require: '^^pxSitesTree',
      restrict: 'E',
      scope: {
        items: '=',
        target: '='
      },
      templateUrl: 'app/components/sites/sitesTree/treeParts/treeItems.template.html',
      link: function (scope, element, attrs, sitesTreeCtrl) {
        scope.sitesTreeCtrl = sitesTreeCtrl;
      }
    };
  }

  pxTreeItems.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxTreeItems', pxTreeItems);

})();
